import {
    TypographyStyle8,
    TypographyStyle9,
    TypographyStyle43,
} from '@cfra-nextgen-frontend/shared/src/components/Typography/StyledTypography';
import { fontFamilies } from '@cfra-nextgen-frontend/shared/src/utils/fonts';
import { styled, Typography } from '@mui/material';

// ─── Reused from shared (with minor overrides) ────────────────────────────────

/** GraphikRegular 13px #002B5A — form field label */
export const LabelTypography = styled(TypographyStyle43)(() => ({
    fontSize: '13px', // TypographyStyle43 is 13.5px
}));

/** GraphikRegular 11px #57626A — hint text below search input */
export const HintTypography = styled(TypographyStyle8)(() => ({
    color: '#57626A', // TypographyStyle8 is #808080
}));

/** GraphikMedium 13px #57626A — detail row labels */
export const DetailLabelTypography = styled(TypographyStyle9)(() => ({
    color: '#57626A', // TypographyStyle9 is #5A5A5A
}));

/** GraphikRegular 13px #002B5A — detail row values */
export const DetailValueTypography = styled(TypographyStyle43)(() => ({
    fontSize: '13px', // TypographyStyle43 is 13.5px
}));

/** GraphikRegular 13px #57626A — card subtitle / secondary text */
export const CardSubtitleTypography = styled(TypographyStyle43)(() => ({
    fontSize: '13px',
    color: '#57626A', // TypographyStyle43 is #002B5A
}));

// ─── Accessibility-specific styled components ─────────────────────────────────

/** Section label in uppercase — e.g. "FIND A SECURITY" */
export const SectionHeaderTypography = styled(Typography)(() => ({
    fontFamily: fontFamilies.GraphikMedium,
    fontSize: '11px',
    color: '#57626A',
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
}));

/** Primary name line in each search result row */
export const ResultNameTypography = styled(Typography)(() => ({
    fontFamily: fontFamilies.GraphikMedium,
    fontSize: '12px',
    color: '#002B5A',
    whiteSpace: 'normal',
    wordBreak: 'break-word',
}));

/** Inline ticker inside the result name line */
export const ResultTickerTypography = styled(Typography)(() => ({
    fontFamily: fontFamilies.GraphikRegular,
    fontSize: '11px',
    color: '#57626A',
}));

/** Exchange line below the name in each search result row */
export const ResultExchangeTypography = styled(Typography)(() => ({
    fontFamily: fontFamilies.GraphikRegular,
    fontSize: '11px',
    color: '#57626A',
    whiteSpace: 'normal',
    wordBreak: 'break-word'
}));

/** Title in the security details card — ticker_full / ticker */
export const CardTitleTypography = styled(Typography)(() => ({
    fontFamily: fontFamilies.GraphikMedium,
    fontSize: '20px',
    color: '#002B5A',
    lineHeight: 1.2,
}));

/** Empty-state primary message */
export const EmptyStateTitleTypography = styled(Typography)(() => ({
    fontFamily: fontFamilies.GraphikMedium,
    fontSize: '16px',
    color: '#57626A',
}));

/** Empty-state secondary message */
export const EmptyStateSubtitleTypography = styled(Typography)(() => ({
    fontFamily: fontFamilies.GraphikRegular,
    fontSize: '13px',
    color: '#888',
}));

/** Title on the dark navy chart-data-section header — security name + chart title */
export const ChartDataSectionHeaderTitleTypography = styled(Typography)(() => ({
    fontFamily: fontFamilies.GraphikMedium,
    fontSize: '16px',
    color: '#fff',
    lineHeight: 1.3,
}));

/** Subtitle line under the header title — report type + report date */
export const ChartDataSectionHeaderSubtitleTypography = styled(Typography)(() => ({
    fontFamily: fontFamilies.GraphikRegular,
    fontSize: '12px',
    color: 'rgba(255,255,255,0.75)',
    marginTop: '4px',
}));

/** "Read a specific data point" section heading (perf10k-specific) */
export const Perf10kSectionTitleTypography = styled(Typography)(() => ({
    fontFamily: fontFamilies.GraphikMedium,
    fontSize: '13px',
    color: '#002B5A',
}));
